import "./installApp.js";
import "./styles/main.css";
import { Router } from "./shared/router/Router.js";
import { AuthService } from "./shared/services/AuthService.js";

const initApp = async() => {
  const isAuthenticated = await AuthService.checkAuth();
  const router = new Router(isAuthenticated);
  router.init();
};

document.addEventListener("DOMContentLoaded", initApp);
